import { UseInfiniteQueryOptions, useQuery } from '@lumapps/base-api/react-query';
import { ONE_MINUTE } from '@lumapps/utils/time/constants';

import { instanceQueryKeys, listInstanceSiblings } from '../api';
import { ListInstanceSiblingsParams } from '../api/types';
import { MINIMAL_INSTANCE_FIELDS_ARRAY } from '../constants';

/**
 * Search instances with react-query infinite scroll
 */
export function useQueryInstanceSiblings(
    params: ListInstanceSiblingsParams,
    options?: Omit<UseInfiniteQueryOptions, 'queryKey' | 'queryFn' | 'getNextPageParam'>,
) {
    const baseParams = {
        ...params,
        fields: params?.fields ?? MINIMAL_INSTANCE_FIELDS_ARRAY.join(','),
    };
    return useQuery({
        ...options,
        queryKey: instanceQueryKeys.siblingsList(baseParams),
        queryFn: async ({ signal }) => {
            const result = await listInstanceSiblings({ ...baseParams }, signal);
            return result.items;
        },
        staleTime: 5 * ONE_MINUTE,
    });
}
